// src/components/PIIAnonymizerPage/usePIIProtocols.js
import { useEffect, useState } from 'react';
import { getLogProtocols } from '../../../services/logProtocolsService';

const usePIIProtocols = () => {
  const [protocols, setProtocols] = useState([]);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [pageSize, setPageSize] = useState(null); // inferred from API
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadProtocols = async (pageToLoad = page) => {
    setLoading(true);
    setError(null);
    try {
      // your service only needs "page"
      const data = await getLogProtocols(pageToLoad);
      const results = data.results || [];

      setProtocols(results);
      setTotalCount(data.count ?? 0);

      // infer pageSize from current page results if not set
      if (!pageSize && results.length > 0) {
        setPageSize(results.length);
      }

      setPage(pageToLoad);
    } catch (e) {
      setError(e.message || 'Failed to load protocols.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadProtocols(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const effectivePageSize = pageSize || (protocols.length || 1);
  const totalPages =
    effectivePageSize > 0
      ? Math.max(1, Math.ceil((totalCount || 0) / effectivePageSize))
      : 1;

  const canGoPrev = page > 1;
  const canGoNext = page < totalPages;

  const goToPrev = () => {
    if (canGoPrev) loadProtocols(page - 1);
  };

  const goToNext = () => {
    if (canGoNext) loadProtocols(page + 1);
  };

  return {
    protocols,
    page,
    totalPages,
    loading,
    error,
    reload: () => loadProtocols(page),
    goToPrev,
    goToNext,
    canGoPrev,
    canGoNext,
  };
};

export default usePIIProtocols;
